import apiFetch from '../apiFetch'

export default function (dossierFinancingComponent, saleId, token) {
  return apiFetch({ endPoint: `dossier/sale/ReactivatedFinancing/${saleId}`, method: 'PUT', body: dossierFinancingComponent, token: token })
}
